import { Users } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import Image from "next/image"

const OrganizationDetails = ({
  name,
  logoUrl,
}: {
  name: string
  logoUrl: string | null
}) => {
  return (
    <div className="flex gap-2 items-center justify-between">
      {logoUrl ? (
        <div className="flex items-center justify-center rounded-[8px] flex-shrink-0 h-[24px] w-[24px]">
          <Image
            src={logoUrl}
            alt={name}
            width={18}
            height={18}
            style={{ borderRadius: "4px" }}
          />
        </div>
      ) : (
        <div className="flex items-center justify-center p-1 rounded mr-1 flex-shrink-0 bg-neutral-500/20 h-[24px] w-[24px]">
          <Icon as={Users} width={12} height={12} />
        </div>
      )}
      <div className="text-sm truncate break-words">
        <span title={name}>{name}</span>
      </div>
    </div>
  )
}

export default OrganizationDetails
